import React from "react";

import "./formControl.styles.scss";

interface FormControlProps {
  children: any;
  isInvalid?: any;
}

const FormControl = ({ children, isInvalid }: FormControlProps) => (
  <div
    className={`formControl ${isInvalid ? "formControl-hasError" : ""}`}
    role="group"
  >
    {children}
  </div>
);

export default FormControl;
